/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface NewEnrollmentRow
 */
export interface NewEnrollmentRow {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof NewEnrollmentRow
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof NewEnrollmentRow
     */
    studentName: string;
    /**
     * 
     * @type {string}
     * @memberof NewEnrollmentRow
     */
    className: string;
    /**
     * 
     * @type {any}
     * @memberof NewEnrollmentRow
     */
    enrolledAt: any | null;
    /**
     * 
     * @type {string}
     * @memberof NewEnrollmentRow
     */
    status: string;
}

/**
 * Check if a given object implements the NewEnrollmentRow interface.
 */
export function instanceOfNewEnrollmentRow(value: object): value is NewEnrollmentRow {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('studentName' in value) || value['studentName'] === undefined) return false;
    if (!('className' in value) || value['className'] === undefined) return false;
    if (!('enrolledAt' in value) || value['enrolledAt'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function NewEnrollmentRowFromJSON(json: any): NewEnrollmentRow {
    return NewEnrollmentRowFromJSONTyped(json, false);
}

export function NewEnrollmentRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewEnrollmentRow {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'studentName': json['studentName'],
        'className': json['className'],
        'enrolledAt': json['enrolledAt'],
        'status': json['status'],
    };
}

export function NewEnrollmentRowToJSON(json: any): NewEnrollmentRow {
    return NewEnrollmentRowToJSONTyped(json, false);
}

export function NewEnrollmentRowToJSONTyped(value?: NewEnrollmentRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'studentName': value['studentName'],
        'className': value['className'],
        'enrolledAt': value['enrolledAt'],
        'status': value['status'],
    };
}

